'use client';

import { Fragment } from 'react';

import Portal from '@mui/material/Portal';
import { styled } from '@mui/material/styles';

import { BrandCube } from '../logo';

/** 큐브 한 변(px) */
const SIZE = 160;

// ----------------------------------------------------------------------

/**
 * 화면 전환 중 로딩 표시 — 윗층이 90°씩 계속 도는 브랜드 큐브 스피너(`loader`).
 *
 * 🔑 놓인 칸과 무관하게 **뷰포트 한가운데**에 뜬다(고정 위치). 누름은 막지 않는다 — 내비게이션이 그대로 쓰인다.
 */
export function LoadingScreen({ portal, sx, ...other }: { portal?: boolean; sx?: any } & Record<string, any>) {
  const PortalWrapper = portal ? Portal : Fragment;

  return (
    <PortalWrapper>
      <LoadingContent sx={sx} {...other}>
        <BrandCube anim="loader" size={SIZE} background={false} label="불러오는 중" />
      </LoadingContent>
    </PortalWrapper>
  );
}

// ----------------------------------------------------------------------

const LoadingContent = styled('div')(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  zIndex: theme.zIndex.modal - 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
}));
